<script lang="ts">
    import { _ } from "svelte-i18n"
    import { langField } from "../../../../i18n"

    let { product }: { product: Product } = $props()
    const hasAnyInformations = !!(
        product.filter_params.external_dimension_width ||
        product.filter_params.external_dimension_height ||
        product.filter_params.external_dimension_depth ||
        product.filter_params.weight ||
        langField(product.scope_of_delivery) ||
        (product.downloads?.de && product.downloads.de.length > 0)
    )
    const hasDimensions = !!(
        product.filter_params.external_dimension_width ||
        product.filter_params.external_dimension_height ||
        product.filter_params.external_dimension_depth
    )
</script>

{#if hasAnyInformations}
    <section>
        <h2 class="h3" id="product-details">
            {#if product.downloads?.de && product.downloads.de.length > 0}
                {$_("product.product-details-and-downloads")}
            {:else}
                {$_("product.product-details")}
            {/if}
        </h2>
        <ul>
            {#if hasDimensions}
                <li>
                    <h3 class="h4">{$_("product.measurements")}</h3>
                    <p>
                        {#if product.filter_params.external_dimension_width}
                            {product.filter_params.external_dimension_width}
                        {/if}
                        {#if product.filter_params.external_dimension_width && product.filter_params.external_dimension_height}
                            x
                        {/if}
                        {#if product.filter_params.external_dimension_height}
                            {product.filter_params.external_dimension_height}
                        {/if}
                        {#if (product.filter_params.external_dimension_width || product.filter_params.external_dimension_height) && product.filter_params.external_dimension_depth}
                            x
                        {/if}
                        {#if product.filter_params.external_dimension_depth}
                            {product.filter_params.external_dimension_depth}
                        {/if}
                        {#if product.filter_params.external_dimension_width || product.filter_params.external_dimension_height || product.filter_params.external_dimension_depth}
                            {$_("product.mm")}
                            {#if product.filter_params.external_dimension_width}
                                (B{#if product.filter_params.external_dimension_height}
                                    x&nbsp;H&nbsp;
                                {/if}{#if product.filter_params.external_dimension_depth}x T
                                {/if})
                            {:else if product.filter_params.external_dimension_height}
                                (H&nbsp;{#if product.filter_params.external_dimension_depth}x&nbsp;{/if})
                            {:else if product.filter_params.external_dimension_depth}
                                (&nbsp;T&nbsp;)
                            {/if}
                        {/if}
                    </p>
                </li>
            {/if}
            {#if !!product.filter_params.weight}
                <li>
                    <h3 class="h4">{$_("product.weight")}</h3>
                    <p>
                        {product.filter_params.weight || $_("product.unknown")}
                        {$_("product.kg")}
                    </p>
                </li>
            {/if}
            {#if langField(product.scope_of_delivery)}
                <li>
                    <h3 class="h4">{$_("product.scopeOfDelivery")}</h3>
                    <p>
                        {langField(product.scope_of_delivery) || $_("product.unknown")}
                    </p>
                </li>
            {/if}
            {#if product.downloads?.de && product.downloads.de.length > 0}
                <li>
                    <h3 class="h4">{$_("product.downloads")}</h3>
                    <ul class="downloadlist">
                        {#each langField(product.downloads) as d}
                            <li>
                                <a href={d?.file?.src} target="_black">
                                    <span class="icon">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M18 20.289L21.288 17L20.6 16.312L18.5 18.412V13.525H17.5V18.412L15.4 16.312L14.712 17L18 20.289ZM14.5 23.5V22.5H21.5V23.5H14.5ZM6.116 19.5C5.68133 19.5 5.30333 19.3393 4.982 19.018C4.66067 18.6967 4.5 18.3187 4.5 17.884V4.116C4.5 3.68133 4.66067 3.30333 4.982 2.982C5.30333 2.66067 5.68133 2.5 6.116 2.5H13L18.5 8V11.14H17.5V8.5H12.5V3.5H6.116C5.962 3.5 5.82067 3.564 5.692 3.692C5.56333 3.82 5.49933 3.961 5.5 4.115V17.885C5.5 18.0383 5.564 18.1793 5.692 18.308C5.82 18.4367 5.961 18.5007 6.115 18.5H12.115V19.5H6.116Z"
                                                fill="#464646"
                                            ></path>
                                        </svg>
                                    </span>
                                    {d.label || d.file.path}
                                </a>
                            </li>
                        {/each}
                    </ul>
                </li>
            {/if}
        </ul>
    </section>
{/if}

<style lang="less">
    @import "../../../../css/variables.less";
    section {
        padding: 2.4rem 0px;
        ul {
            display: grid;
            gap: 1.2rem;
            grid-template-columns: 1fr 1fr;
            @media @max-mobile {
                grid-template-columns: 1fr;
            }
            h3 {
                border-bottom: 1px solid var(--grey-400);
                padding-bottom: 0.6rem;
                margin-bottom: 0.6rem;
            }
            .downloadlist {
                list-style-type: none;
                margin: 0;
                padding: 0;
                display: flex;
                flex-direction: column;
                gap: 0.6rem;

                li a {
                    display: flex;
                    align-items: center;
                    color: var(--grey-400);
                    .icon {
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
</style>
